import React from "react";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main
        className="flex min-h-dvh items-center justify-center bg-gray-50 p-4"
        role="alert"
      >
        <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 text-center shadow-sm sm:p-8">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-xl text-red-600">
            !
          </div>
          <h1 className="mt-4 text-xl font-semibold text-gray-900">
            This page could not be displayed
          </h1>
          <p className="mt-2 text-sm leading-6 text-gray-600">
            Reload the admin portal and check the last action before trying it
            again.
          </p>
          <button
            type="button"
            onClick={this.handleRetry}
            className="mt-6 min-h-11 rounded-xl bg-amber-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
          >
            Reload admin portal
          </button>
        </div>
      </main>
    );
  }
}

export default AppErrorBoundary;
